import { Button, CircularProgress, FormControlLabel, Checkbox, Dialog, DialogActions, DialogContent, Divider, Grid, IconButton } from '@mui/material'
import React, { useEffect, useState } from 'react'
import DashboardContainer from '../../components/DashboardContainer'
import PageContainer from '../../components/PageContainer'
import { AddorUpdateRecord, getList } from '../../redux/api/system'
import { Formik, Form } from 'formik'
import { useSnackbar } from 'notistack'
import { DataGrid } from '@mui/x-data-grid'
import TextInput from '../../components/common/TextInput'
import SelectInput from '../../components/common/SelectInput'
import { Edit } from '@mui/icons-material';
import CustomDataGrid from '../../components/CustomDataGrid'

const Institutions = () => {
    const [ showModal, setShowModal ] = useState(false)
    const [ processing, setProcessing ] = useState(false)
    const [ isEditing, setEditing ] = useState(false)
    const [ selectedInstitution, setSelectedInstitution ] = useState(null);
    const [ institutions, setInstitutions ] = useState([]);
    const { enqueueSnackbar } = useSnackbar();
    const defaultRole = {
        "id": "",
        "institutionName": "",
        "mnemonic": "",
        "subsidiaryOf": "",
        "apI_Client": {
            "apIkey": "",
            "enabled": ""
        },
        "isFRSCCMember": false
    }

    const columns = [
        { 
            field: 'sn', headerName: 'S/N', flex: 0.1, sortable: false,
            renderCell: (params) => (
                <p
                    style={{ margin: 'auto' }}
                >
                    {params?.row?.sn}
                </p>
            )
        },
        
        {
            field: 'actions', headerName: 'Actions', flex: 0.1, sortable: false,
            renderCell: (params) => (
                <div className='action-icons' style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', width: '100%', padding: '0 0.5rem' }}>
                    <IconButton
                        size='small'
                        color="primary"
                        variant="outlined" title='Edit Dataset Domain' className='p-0 m-0'
                        onClick={() => {
                            setSelectedInstitution(params?.row || defaultRole);
                            setShowModal(true); setEditing(true);
                        }}
                    >
                        <Edit />
                    </IconButton>
                </div>
            )
        },
        { field: 'institutionName', headerName: 'Institution Name', flex: 1 },
    ];

    const init = async () => {
        try {
            setProcessing(true)
            const resp = await getList("institutions");
            if(resp?.responseCode === "00") {
                setInstitutions(resp?.listing || [])
            } else {
                enqueueSnackbar(resp?.message || resp?.responseMessage || 'An error occurred', { variant: 'error' })
            }
        }
        catch (err) {
            enqueueSnackbar(err?.message || err?.responseMessage || 'An error occurred', { variant: 'error' })
        }
        finally {
            setProcessing(false)
        }
    }

    const createOrUpdateRole = async (values, { resetForm }) => {
        try {
            const resp = await AddorUpdateRecord("institution", isEditing ? "update" : 'add', { ...values, subsidiaryOf: values?.subsidiaryOf ? values?.subsidiaryOf : values.institutionCode });
            if(resp?.responseCode === "00") {
                init();
                enqueueSnackbar('Action performed successfully')
                setEditing(false);
                setSelectedInstitution(null)
                setShowModal(false)
            } else {
                enqueueSnackbar(resp?.message || resp?.responseMessage || 'An error occurred', { variant: 'error' })
            }
        }
        catch (err) {
            enqueueSnackbar(err?.message || err?.responseMessage || 'An error occurred', { variant: 'error' })
        }
    }

    useEffect(() => {
        init()
    }, [])

    return (
        <PageContainer pageTitle='Users' processing={processing}>
            <section className="inner-banner parallax-section">
                <div className='overlay'>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 col-sm-12">
                                <h3 className="wow bounceIn" data-wow-delay="0.9s">All</h3>
                                <h1 className="wow fadeInUp text-uppercase conference mb-05 mt-05" data-wow-delay="1.6s">Institutions</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className="services-area section-padding pt-3">
                <div className="container">
                    <div className="row">
                        <div className='col-12 text-align-right'>
                            <Button variant="contained" onClick={() => { setSelectedInstitution(defaultRole); setEditing(false); setShowModal(true) }}>Create New Institution</Button>
                        </div>
                        <div className='col-12 mt-4'>
                            <div style={{ height: 600, width: '100%', textAlign: 'center' }}>
                                <CustomDataGrid 
                                    columns={columns}
                                    rows={institutions}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Dialog open={showModal}>
                <Formik 
                    enableReinitialize 
                    initialValues={{ ...selectedInstitution, 
                        apI_Client: { ...selectedInstitution?.apI_Client, enabled: String(selectedInstitution?.apI_Client?.enabled) } 
                    }} 
                    onSubmit={createOrUpdateRole}>
                    {({ isSubmitting, values, setFieldValue }) => (
                        <Form>
                            <DialogContent className='pl-3 pr-3'>
                                <h3 className='text-bold mt-05' >{isEditing ? 'Update' : 'Create'} Institution</h3>
                                <Divider className="mt-05 mb-2" />
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <TextInput readOnly={isEditing} id="id" required label="Institution Code" />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextInput id="institutionName" label="Institution Name" />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextInput id="mnemonic" label="Mnemonic" />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextInput id="apI_Client.apIkey" label="API key" />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <SelectInput options={[
                                            { code: "true" }, { code: "false" }
                                        ]} id="apI_Client.enabled" label="API Enabled" field="code" fieldDisplay='code' />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox checked={values.isFRSCCMember} />
                                            }
                                            label={<b className='f-15'>Add to FSRCC Institutions</b>}
                                            name={"isFRSCCMember"}
                                            onChange={() => setFieldValue('isFRSCCMember', !values.isFRSCCMember)}
                                        />
                                    </Grid>
                                </Grid>
                            </DialogContent>
                            <DialogActions className='pr-3 pb-3'>
                                <Button onClick={() => { if(!isSubmitting) { setShowModal(false); selectedInstitution(null) }}} color="secondary" variant="contained" >Cancel</Button>
                                <Button type='submit' variant="contained">
                                    {
                                        isSubmitting ?
                                        <CircularProgress size={15} color="inherit" />
                                        :
                                        isEditing ? 'Update Institution' : 'Add Institution'
                                    }
                                </Button>
                            </DialogActions>
                        </Form>
                    )}
                </Formik>
            </Dialog>
        </PageContainer>
    )
}

export default Institutions